import { render, staticRenderFns } from "./CardTarjaEnqueteF1SportvQRCODE.vue?vue&type=template&id=a120fa46&scoped=true"
import script from "./CardTarjaEnqueteF1SportvQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteF1SportvQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteF1SportvQRCODE.vue?vue&type=style&index=0&id=a120fa46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a120fa46",
  null
  
)

export default component.exports